import { configureStore } from '@reduxjs/toolkit';

import templateReducer from './features/template/slice'

export const store = configureStore({
    reducer: {
        template:templateReducer,
    },
});
